<template>
    <div class="fullscreen p-5 d-flex align-items-center overflow-auto">
        <div class="m-auto d-flex flex-column align-items-center">
            <img
                src="@/assets/img/illustrations/woman-pointing-finger.svg"
                alt="Woman with a laptop pointing finger to the side"
                role="presentation" />
            <h3 class="text-center mt-5" v-dompurify-html="t('mobileView.looksLikeMobile')"></h3>
            <span class="text-center mt-2" v-dompurify-html="t('mobileView.mobileNotSupported')"></span>
            <form @submit.prevent="continueOnMobile = true">
                <b-button variant="link" type="submit" class="fw-bold mt-3 mb-3">{{
                    t('mobileView.backToHomepage')
                }}</b-button>
            </form>
            <span class="text-center" v-dompurify-html="t('mobileView.contactUs', { contactEmail })"></span>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useSessionStorage } from '@vueuse/core';

const { t } = useI18n();

const contactEmail = 'info@sagacityintelligence.com';

const continueOnMobile = useSessionStorage('continueOnMobile', false);
</script>

<style scoped lang="scss">
.fullscreen {
    width: 100lvw;
    height: 100lvh;
    background-color: white;
}

img {
    max-width: 100%;
}

span {
    color: var(--#{$prefix}gray-800);
}
</style>
